export default {
  WEEEQuestion: 'WEEE常见问题汇总',
  PACKAGINGQuestion: '包装法常见问题汇总',
  BATTERYQuestion: '电池法常见问题汇总',
  EPRQuestion: 'EPR常见问题汇总',
}